import { USERS } from "configurations/Urls";
import apiClient from "utils/ApiClient";
import { LOCAL_STORAGE_KEYS } from "configurations/Constants";

const USERS_PUBLIC = `${USERS}/public`;

const UserService = {
  async userLogin(email, password) {
    const response = await apiClient.post(`${USERS_PUBLIC}/login`, {
      email,
      password,
    });
    return response.data;
  },

  async userRegister(userData) {
    const response = await apiClient.post(`${USERS_PUBLIC}/register`, userData);
    return response.data.data;
  },

  async confirmCode(email, confirmationCode) {
    const response = await apiClient.post(`${USERS_PUBLIC}/confirm`, {
      email,
      confirmationCode,
    });
    return response.data;
  },

  async resendConfirmationCode(email) {
    const response = await apiClient.post(
      `${USERS_PUBLIC}/resend-confirmation`,
      { email }
    );
    return response.data.data;
  },

  async sendResetPasswordCode(email) {
    const response = await apiClient.post(`${USERS_PUBLIC}/forgot-password`, {
      email,
    });
    return response;
  },

  async refreshToken(email, refreshToken) {
    const response = await apiClient.post(`${USERS_PUBLIC}/refresh-token`, {
      email,
      refreshToken,
    });
    return response.data;
  },

  async resetPassword(email, newPassword, confirmationCode) {
    const response = await apiClient.post(
      `${USERS_PUBLIC}/confirm-forgot-password`,
      { email, newPassword, confirmationCode }
    );
    return response.data.data;
  },

  async getUserProfile() {
    const response = await apiClient.get(`${USERS}/profile`);
    return response.data;
  },

  async updateUserProfile(userData) {
    const response = await apiClient.put(`${USERS}/profile`, userData);
    return response.data;
  },

  async changePassword(oldPassword, newPassword) {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const response = await apiClient.post(`${USERS}/change-password`, {
      accessToken,
      oldPassword,
      newPassword,
    });
    return response.data.data;
  },

  async getFarmsBusinesses() {
    const response = await apiClient.get(`${USERS}/businesses-and-farms`);
    return response.data.data;
  },

  async getUserFromMobileNumber(mobileNumber) {
    const response = await apiClient.get(
      `${USERS}/search?phone=${mobileNumber}`
    );
    return response.data;
  },
};

export default UserService;
